<template>
    <v-main class="mt-n16">
        <v-main class="mt-n10 px-sm-3 mb-n7" fluid>
            <v-row>
                <v-col cols="12" xs="12" md="12" lg="7">
                    <ClientListTable></ClientListTable>
                </v-col>

                <v-col cols="12" xs="12" md="12" lg="5">
                    <FactoryListTable></FactoryListTable>
                </v-col>
            </v-row>

            <v-container class="mt-10 mb-10"></v-container>
        </v-main>
    </v-main>
</template>

<script>
import ClientListTable from "@/components/admin/table/ClientListTable";
import FactoryListTable from "@/components/admin/table/FactoryListTable";

export default {
    name: 'Clients',
    components: {
        ClientListTable,
        FactoryListTable,
    },
    created: function() {
    },
    beforeCreate: function() {

        if(!this.$store.getters.getAccessToken){
            this.$router.push('/user/login')
        }

    }
}
</script>